<template>
  <div class="pointList">
    <div class="intes-bt">需重点关注器官</div>
    <van-collapse v-model="activeNames">
      <van-collapse-item
        :name="index"
        v-for="(item, index) in list"
        :key="index"
      >
        <template #title>
          <div class="pointImg">
            <img :src="require(`@/assets/image/chang/${item.name}.png`)" />{{
              item.name
            }}
          </div>
        </template>
        <div>
          <markbox :item="item"></markbox>
          <div class="intes-cjfx">
            <div>
              <h3>常见风险</h3>
              <p v-html="item.remakrs"></p>
            </div>
            <div>
              <h3>健康管理建议</h3>
              <p v-html="item.exam_references"></p>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <div v-show="list.length == 0" style="text-align: center">暂无数据</div>
  </div>
</template>
<script>
import markbox from "./markBox.vue"
export default {
  props: ['list'],
  components: { markbox },
  data () {
    return {
      activeNames: [],
      risklist: []
    }
  },
  watch: {
    list (newVal) {
      this.list = newVal;
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.intes-cjfx {
  padding: 30px;

  background: #f4faff;
  font-size: 26px;
  div {
    margin-bottom: 30px;
  }
  div:last-child {
    margin-bottom: 0;
  }
  h3 {
    color: #3195e6;
    margin: 0;
  }
  p {
    color: #333;
    margin: 0;
  }
}
</style>